import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import RotateRightIcon from '@material-ui/icons/RotateRight';
import RotateLeftIcon from '@material-ui/icons/RotateLeft';
import { Box, IconButton, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { normalizeRotation } from '@buseditor/components';
const scaleValues = [0.5, 0.67, 0.75, 0.8, 0.9, 1, 1.1, 1.25, 1.5, 1.75, 2];
const getNearestScaleIndex = (value) => {
    if (!Number.isFinite(value))
        return 0;
    const exact = scaleValues.indexOf(value);
    if (exact >= 0)
        return exact;
    let nearest = 0;
    let minDiff = Number.POSITIVE_INFINITY;
    for (let i = 0; i < scaleValues.length; i++) {
        const diff = Math.abs(scaleValues[i] - value);
        if (diff < minDiff) {
            minDiff = diff;
            nearest = i;
        }
    }
    return nearest;
};
export function BookerViewControls(props) {
    const nearestScaleIndex = useMemo(() => getNearestScaleIndex(props.scale), [props.scale]);
    const canZoomOut = props.scale > scaleValues[0];
    const canZoomIn = props.scale < scaleValues[scaleValues.length - 1];
    return (React.createElement(Box, { style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '8px', marginBottom: '8px' } },
        React.createElement(IconButton, { size: "small", disabled: !canZoomOut, onClick: () => props.onScaleChange(scaleValues[Math.max(0, nearestScaleIndex - 1)]) },
            React.createElement(ZoomOutIcon, null)),
        React.createElement(Typography, { variant: "body2", style: { minWidth: '44px', textAlign: 'center' } },
            Math.round(props.scale * 100),
            "%"),
        React.createElement(IconButton, { size: "small", disabled: !canZoomIn, onClick: () => props.onScaleChange(scaleValues[Math.min(scaleValues.length - 1, nearestScaleIndex + 1)]) },
            React.createElement(ZoomInIcon, null)),
        React.createElement(IconButton, { size: "small", onClick: () => props.onRotationChange(normalizeRotation(props.rotation + 90)) },
            React.createElement(RotateLeftIcon, null)),
        React.createElement(IconButton, { size: "small", onClick: () => props.onRotationChange(normalizeRotation(props.rotation + 90)) },
            React.createElement(RotateRightIcon, null))));
}
